/*********************************************************************
 * The Initial Developer of the content of this file is NETCONOMY.
 * All portions of the code written by NETCONOMY are property of
 * NETCONOMY. All Rights Reserved.
 *
 * NETCONOMY Software & Consulting GmbH
 * Hilmgasse 4, A-8010 Graz (Austria)
 * FN 204360 f, Landesgericht fuer ZRS Graz
 * Tel: +43 (316) 815 544
 * Fax: +43 (316) 815544-99
 * www.netconomy.net
 *
 * (c) 2022 by NETCONOMY Software & Consulting GmbH
 *********************************************************************/

const storeStockists = {
    showMoreClass: '.stockist-more--show',
    showLessClass: '.stockist-more--hide',
    hideClass:     'd-none',
    init() {
        const showMore = $('.stockist-more');

        showMore.on('click', this.showMoreClass, this.showMore);
        showMore.on('click', this.showLessClass, this.showLess);
    },

    showMore(event) {
        const $this = $(event.target);
        $this.addClass(storeStockists.hideClass);
        $this.siblings(storeStockists.showLessClass).removeClass(storeStockists.hideClass)
        $this.parent().siblings('.sub-stockist').removeClass(storeStockists.hideClass);
    },

    showLess(event) {
        const $this = $(event.target);
        $this.addClass(storeStockists.hideClass);
        $this.siblings(storeStockists.showMoreClass).removeClass(storeStockists.hideClass)
        $this.parent().siblings('.sub-stockist').addClass(storeStockists.hideClass);
    }

}

$(() => {
    if($('.stores-wrapper').length){
        storeStockists.init();
    }
})



